import React, { useState } from "react";
import { Link } from "gatsby";
import Logo from "../images/horizontal-logo.png";

export default function Navigation() {
  const [collapsed, setCollapsed] = useState(true);

  function NavLink({ to, children }) {
    return (
      <li>
        <Link
          to={to}
          className="text-white uppercase"
          activeClassName="font-bold"
          onClick={() => {
            setCollapsed(true);
          }}
        >
          {children}
        </Link>
      </li>
    );
  }

  return (
    <nav className="fixed z-20 w-full">
      <div className="relative bg-white z-20 flex flex-row flex-wrap justify-between px-4 md:px-8 py-2">
        <a href="/">
          <img src={Logo} className="h-12" alt="Maryville Logo" />
        </a>
        <div className="flex h-auto my-auto">
          <Link
            to="/get-info"
            className="uppercase mr-8"
            onClick={() => {
              setCollapsed(true);
            }}
          >
            Get Info
          </Link>
          <Toggler
            handleClick={() => {
              setCollapsed(!collapsed);
            }}
            collapsed={collapsed}
          />
        </div>
      </div>
      <div
        className={`z-10 justify-center bg-gray absolute w-full transition-transform duration-500 transform ${
          collapsed ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <ul className={`text-center my-8`}>
          <NavLink to="/">Why Maryville</NavLink>
          <NavLink to="/how-to-apply">How to Apply</NavLink>
          <NavLink to="/saint-louis">Living in St. Louis</NavLink>
          <NavLink to="/explore-the-city">Explore the City</NavLink>
          <NavLink to="/academics">Academics</NavLink>
          <NavLink to="/housing-and-dining">Housing &amp; Dining</NavLink>
          <NavLink to="/tuition-and-scholarships">
            Tuition &amp; Scholarships
          </NavLink>
        </ul>
      </div>
    </nav>
  );
}

function Toggler({ handleClick, collapsed }) {
  return (
    <button onClick={handleClick} className={collapsed ? "pl-0" : "pl-2"}>
      <span className="sr-only">Toggle navigation</span>
      <span
        className={`block w-6 h-0.5 mb-1.5 bg-red top-bar transition-transform transform ${
          collapsed ? "rotate-0" : "rotate-45 origin-top-left"
        }`}
      ></span>
      <span
        className={`block w-6 h-0.5 mb-1.5 bg-red middle-bar ${
          collapsed ? "opacity-100" : "opacity-0"
        }`}
      ></span>
      <span
        className={`block w-6 h-0.5 mb-0 bg-red bottom-bar transition-transform transform ${
          collapsed ? "rotate-0" : "-rotate-45 origin-bottom-left"
        }`}
      ></span>
    </button>
  );
}
